import { useState, useEffect } from "react"
import {Plane} from 'lucide-react'
import bgImage from "./img/scene-des-batiments-de-la-ville-indienne.jpg"
import {useNavigate} from "react-router-dom"
import Modal from "./Modal"

const compressImage = (file, maxWidth = 800, quality = 0.7) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const ratio = img.width / img.height;
        const width = Math.min(maxWidth, img.width);
        const height = width / ratio;
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          blob => blob ? resolve(new File([blob], file.name, { type: blob.type })) : reject("Compression failed"),
          'image/jpeg',
          quality
        );
      };
      img.onerror = () => reject("Image load error");
      img.src = URL.createObjectURL(file);
    });

const Passports = () => {
    const [passports, setPassports] = useState([])
    const [isDark, setIsDark] = useState(false)
    const [isMobile, setIsMobile] = useState(false)
    const [dragOver, setDragOver] = useState(false)
    const navigate = useNavigate()
    const params = new URLSearchParams(window.location.search);
    const dossierId = params.get("id");
    const [modal, setModal] = useState({
        show: false,
        type: 'info',
        message: '',
        autoClose: 0,
        onClose: () => {}
    })
    
    // États pour le popup nom/prénom
    const [showNamePopup, setShowNamePopup] = useState(false)
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    
    if (dossierId) {
      localStorage.setItem("dossierId", dossierId);
      console.log("ID du dossier stocké :", dossierId);
    }

    // Vérifier si le nom/prénom sont déjà stockés
    useEffect(() => {
        const storedFirstName = localStorage.getItem("firstName")
        const storedLastName = localStorage.getItem("lastName")
        
        if (!storedFirstName || !storedLastName) {
            setShowNamePopup(true)
        }
    }, [])

    const handleLastNameChange = (e) => {
        setLastName(e.target.value.toUpperCase())
    }

    // Fonction pour sauvegarder le nom/prénom
    const saveUserName = () => {
        if (firstName.trim() && lastName.trim()) {
            localStorage.setItem("firstName", firstName.trim())
            localStorage.setItem("lastName", lastName.trim())
            setShowNamePopup(false)
        } else {
            setModal({
                show: true,
                type: 'error',
                message: 'Veuillez entrer votre nom et prénom.',
                autoClose: 3000,
                onClose: () => setModal({ show: false })
            })
        }
    }

    // Détecter si on est sur mobile
    useEffect(() => {
        const checkMobile = () => {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const isMobileDevice = /android|iPad|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
            setIsMobile(isMobileDevice);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Détecter le thème du navigateur
    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
        setIsDark(mediaQuery.matches)

        const handleChange = (e) => {
            setIsDark(e.matches)
        }

        mediaQuery.addEventListener('change', handleChange)
        return () => mediaQuery.removeEventListener('change', handleChange)
    }, [])

    // Charger les fichiers depuis localStorage au démarrage
    useEffect(() => {
        const savedPassports = localStorage.getItem("passports")
        if (savedPassports) {
            try {
                const parsedData = JSON.parse(savedPassports)
                setPassports(parsedData)
            } catch (error) {
                console.error("Erreur lors du chargement des passeports:", error)
            }
        }
    }, [])

    // Sauvegarder dans localStorage à chaque modification
    const saveToLocalStorage = (newPassports) => {
        localStorage.setItem("passports", JSON.stringify(newPassports))
    }

    const uploadFiles = () => {
        if (passports.length > 0) {
            console.log(passports)
            setModal({
                show: true,
                type: 'success',
                message: 'Votre passport à bien été enregistrée',
                autoClose: 0,
                onClose: () => {
                    setModal({ show: false })
                    navigate('/identitycard')
                }
            })
        } else {
            setModal({
                show: true,
                type: 'error',
                message: 'Veuillez sélectionner au moins un fichier avant de continuer.',
                autoClose: 0,
                onClose: () => setModal({ show: false })
            })
        }
    }

    const handleFileSelect = (files) => {
        Array.from(files).forEach(async file => {
            if (file && file.type.startsWith('image/')) {
                // 1) compresser chaque image
                 let toRead = file
                 try {
                   toRead = await compressImage(file)
                 } catch (err) {
                   console.warn("Compression échouée, on lit l’original", err)
                 }
                 const reader = new FileReader()
                reader.onload = () => {
                    const fileData = {
                        id: Date.now() + Math.random(),
                        name: toRead.name,
                        size: toRead.size,
                        type: toRead.type,
                        data: reader.result,
                        timestamp: new Date().toISOString()
                    }
                    
                    setPassports(prev => {
                        const newPassports = [...prev, fileData]
                        saveToLocalStorage(newPassports)
                        return newPassports
                    })
                }
                reader.readAsDataURL(toRead)
            }
        })
    }

    const handleFileInput = (e) => {
        e.preventDefault()
        const files = e.target.files
        if (files) {
            handleFileSelect(files)
        }
    }

    const handleCameraCapture = async (e) => {
        const file = e.target.files[0];
          if (file) {
            try {
              // 1) compresser
              const compressedFile = await compressImage(file);
              // 2) traiter comme d’habitude
              handleFileSelect([compressedFile]);
            } catch (err) {
              console.error("Erreur compression passport:", err);
            }
          }
    }

    const handleDrop = (e) => {
        e.preventDefault()
        setDragOver(false)
        const files = e.dataTransfer.files
        if (files) {
            handleFileSelect(files)
        }
    }

    const handleDragOver = (e) => {
        e.preventDefault()
        setDragOver(true)
    }

    const handleDragLeave = (e) => {
        e.preventDefault()
        setDragOver(false)
    }

    const removeFile = (id) => {
        setPassports(prev => {
            const newPassports = prev.filter(passport => passport.id !== id)
            saveToLocalStorage(newPassports)
            return newPassports
        })
    }

    const clearAll = () => {
        setPassports([])
        localStorage.removeItem("passports")
    }

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes'
        const k = 1024
        const sizes = ['Bytes', 'KB', 'MB', 'GB']
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    }

    const themeClasses = isDark ? {
        background: "min-h-screen bg-cover bg-center bg-no-repeat relative",
        backgroundImage: bgImage,
        overlay: "absolute inset-0 bg-black/60 backdrop-blur-sm",
        card: "bg-slate-800/95 backdrop-blur-xl border-slate-700/50",
        header: "bg-gradient-to-r from-orange-600 to-green-600",
        text: "text-slate-200",
        textMuted: "text-slate-400",
        textLight: "text-slate-300",
        uploadArea: dragOver ? "border-orange-400 bg-orange-900/40" : "border-slate-600 hover:border-orange-400 hover:bg-orange-900/20",
        uploadIcon: "bg-slate-700 text-slate-400 group-hover:bg-orange-700 group-hover:text-orange-300",
        button: "bg-gradient-to-r from-orange-600 to-green-600 hover:from-orange-700 hover:to-green-700 shadow-lg shadow-orange-500/25",
        cameraButton: "bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 shadow-lg shadow-green-500/25",
        clearButton: "bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700",
        security: "text-slate-300",
        fileCard: "bg-slate-700/50 border-slate-600/50 hover:bg-slate-700/70"
    } : {
        background: "min-h-screen bg-cover bg-center bg-no-repeat relative",
        backgroundImage: bgImage,
        overlay: "absolute inset-0 bg-white/70 backdrop-blur-sm",
        card: "bg-white/90 backdrop-blur-xl border-white/50",
        header: "bg-gradient-to-r from-orange-600 to-green-600",
        text: "text-slate-700",
        textMuted: "text-slate-500",
        textLight: "text-slate-600",
        uploadArea: dragOver ? "border-orange-400 bg-orange-50/80" : "border-slate-300 hover:border-orange-400 hover:bg-orange-50/80",
        uploadIcon: "bg-white/80 text-slate-500 group-hover:bg-orange-100 group-hover:text-orange-600",
        button: "bg-gradient-to-r from-orange-600 to-green-600 hover:from-orange-700 hover:to-green-700 shadow-lg shadow-orange-500/20",
        cameraButton: "bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 shadow-lg shadow-green-500/20",
        clearButton: "bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600",
        security: "text-slate-600",
        fileCard: "bg-white/70 border-white/50 hover:bg-white/80"
    }

    return (
        <>
        <div 
            className={themeClasses.background}
            style={{ backgroundImage: `url(${themeClasses.backgroundImage})` }}
        >
            
            {/* Contenu principal */}
            <div className="relative z-10 flex items-center justify-center p-4 min-h-screen">
                <div className="w-full max-w-2xl">
                    <div className={`${themeClasses.card} rounded-3xl shadow-2xl overflow-hidden border`}>
                        <div className={`${themeClasses.header} px-8 py-8`}>
                            <div className="flex items-center justify-center mb-6">
                                <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center backdrop-blur-sm">
                                    <Plane />
                                </div>
                            </div>
                            <h2 className="text-2xl font-bold text-white text-center leading-tight">
                                Veuillez insérer une photo ou scan de votre passeport <br /><br /> (La photo ou le scan doit être de bonne qualité)
                            </h2>
                        </div>

                        <div className="p-8">
                            {/* Zone d'upload */}
                            <div className="mb-8">
                                <div className="relative mb-6">
                                    <input 
                                        onChange={handleFileInput} 
                                        type="file"
                                        multiple
                                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                                        accept=".jpg,.jpeg,.png"
                                    />
                                    <div 
                                        className={`border-3 border-dashed ${themeClasses.uploadArea} rounded-2xl p-10 text-center transition-all duration-300 group`}
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                    >
                                        <div className="flex flex-col items-center">
                                            <div className={`w-20 h-20 ${themeClasses.uploadIcon} rounded-2xl flex items-center justify-center mb-6 transition-all duration-300 group-hover:scale-110`}>
                                                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                                </svg>
                                            </div>
                                            <p className={`${themeClasses.textLight} font-semibold text-lg mb-2`}>
                                                Cliquez pour sélectionner
                                            </p>
                                            <p className={`${themeClasses.textMuted} mb-4`}>
                                                ou glissez-déposez vos fichiers ici
                                            </p>
                                            <div className={`px-4 py-2 rounded-full bg-gradient-to-r from-orange-500/20 to-green-500/20 text-sm ${themeClasses.textMuted} border border-purple-200/30`}>
                                                JPG, PNG • Plusieurs fichiers acceptés
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Bouton caméra mobile */}
                                {isMobile && (
                                    <div className="mb-6">
                                        <div className={`text-center text-sm ${themeClasses.textMuted} mb-4 flex items-center justify-center gap-2`}>
                                            <div className="h-px bg-gradient-to-r from-transparent via-current to-transparent flex-1"></div>
                                            <span>ou</span>
                                            <div className="h-px bg-gradient-to-r from-transparent via-current to-transparent flex-1"></div>
                                        </div>
                                        <div className="relative">
                                            <input 
                                                onChange={handleCameraCapture}
                                                type="file"
                                                accept="image/*"
                                                capture="environment"
                                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                                            />
                                            <button className={`w-full ${themeClasses.cameraButton} text-white font-semibold py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-emerald-200/50`}>
                                                <span className="flex items-center justify-center gap-3">
                                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    </svg>
                                                    Prendre une photo
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* Liste des fichiers */}
                                {passports.length > 0 && (
                                    <div className="mb-6">
                                        <div className="flex items-center justify-between mb-4">
                                            <h3 className={`text-lg font-semibold ${themeClasses.text}`}>
                                                Fichiers sélectionnés ({passports.length})
                                            </h3>
                                            <button
                                                onClick={clearAll}
                                                className={`text-sm px-3 py-1 ${themeClasses.clearButton} text-white rounded-lg transition-all duration-200 hover:scale-105`}
                                            >
                                                Tout supprimer
                                            </button>
                                        </div>
                                        <div className="space-y-3 max-h-60 overflow-y-auto">
                                            {passports.map((passport) => (
                                                <div key={passport.id} className={`${themeClasses.fileCard} border rounded-xl p-4 transition-all duration-200`}>
                                                    <div className="flex items-center gap-4">
                                                        <div className="w-12 h-12 rounded-lg overflow-hidden bg-gradient-to-br from-purple-500 to-blue-500 flex-shrink-0">
                                                            <img 
                                                                src={passport.data} 
                                                                alt={passport.name}
                                                                className="w-full h-full object-cover"
                                                            />
                                                        </div>
                                                        <div className="flex-1 min-w-0">
                                                            <p className={`font-medium ${themeClasses.text} truncate`}>
                                                                {passport.name}
                                                            </p>
                                                            <p className={`text-sm ${themeClasses.textMuted}`}>
                                                                {formatFileSize(passport.size)}
                                                            </p>
                                                        </div>
                                                        <button
                                                            onClick={() => removeFile(passport.id)}
                                                            className="w-8 h-8 rounded-full bg-red-500/20 text-red-500 hover:bg-red-500/30 transition-colors flex items-center justify-center flex-shrink-0"
                                                        >
                                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Bouton suivant */}
                            <button
                                onClick={uploadFiles}
                                disabled={passports.length === 0}
                                className={`w-full ${themeClasses.button} text-white font-semibold py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-purple-200/50 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none`}
                            >
                                <span className="flex items-center justify-center gap-3">
                                    <span>Continuer</span>
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>

                    {/* Message de sécurité */}
                    <div className="mt-8 text-center">
                        <div className={`inline-flex items-center gap-3 px-6 py-3 rounded-2xl bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-200/30 backdrop-blur-sm`}>
                            <svg className="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.031 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                            </svg>
                            <p className={`text-sm ${themeClasses.security} font-medium`}>
                                Vos documents sont stockés localement et sécurisés
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Popup pour nom et prénom */}
        {showNamePopup && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                <div className={`${themeClasses.card} rounded-2xl shadow-2xl w-full max-w-md p-6 border`}>
                    <div className="text-center mb-6">
                        <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-green-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                        </div>
                        <h3 className={`text-xl font-bold ${themeClasses.text} mb-2`}>
                            Informations personnelles
                        </h3>
                        <p className={`${themeClasses.textMuted} text-sm`}>
                            Veuillez entrer votre nom et prénom du demandeur pour continuer
                        </p>
                    </div>
                    
                    <div className="space-y-4">
                        <div>
                            <label className={`block text-sm font-medium ${themeClasses.text} mb-2`}>
                                Nom
                            </label>
                            <input
                                type="text"
                                value={lastName}
                                onChange={handleLastNameChange}
                                className={`w-full px-4 py-3 rounded-xl border ${isDark ? 'bg-slate-700/50 border-slate-600 text-slate-200' : 'bg-white/80 border-gray-300 text-gray-700'} focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200`}
                                placeholder="Votre nom"
                            />
                        </div>
                        <div>
                            <label className={`block text-sm font-medium ${themeClasses.text} mb-2`}>
                                Prénom
                            </label>
                            <input
                                type="text"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                className={`w-full px-4 py-3 rounded-xl border ${isDark ? 'bg-slate-700/50 border-slate-600 text-slate-200' : 'bg-white/80 border-gray-300 text-gray-700'} focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200`}
                                placeholder="Votre prénom"
                            />
                        </div>
                    </div>
                    
                    <div className="mt-6 flex gap-3">
                        <button
                            onClick={saveUserName}
                            className={`flex-1 ${themeClasses.button} text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 transform hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-orange-200/50`}
                        >
                            Valider
                        </button>
                    </div>
                </div>
            </div>
        )}

        {modal.show && (
            <Modal 
                type={modal.type} 
                message={modal.message} 
                onClose={modal.onClose} 
                autoClose={modal.autoClose}
            />
        )}
     </> 
    )
}

export default Passports